import api from "@/router/api";

export default {
  async getAllTopicoAjuda() {
    const response = await api.get("/topicos-ajuda");
    return response.data;
  },

  async getTopicoAjudaById(id) {
    const response = await api.get(`/topicos-ajuda/${id}`);
    return response.data;
  },

  async getTopicoAjudaPaginado(page, size) {
    const response = await api.get(`/topicos-ajuda/paginado`, {
      params: {
        page,
        size,
      },
    });
    return response.data;
  },

  async createTopicoAjuda(topico) {
    const response = await api.post("/topicos-ajuda", topico);
    return response.data;
  },

  async updateTopicoAjuda(id, topico) {
    const response = await api.put(`/topicos-ajuda/${id}`, topico);
    return response.data;
  },

  async deleteTopicoAjuda(id) {
    const response = await api.delete(`/topicos-ajuda/${id}`);
    return response.data;
  },
};
